<script>
import Notification from '../../reUse/Notification.vue';
export default {
  components: {
    Notification,
  },
  emits: ['backToAdmin'],
  data() {
    return {
      text: '',
      types: '',
      ShowNoti: false,
      uporabniki: [],
      twoAuthed: [],
      userID: '',
      izbranUser: '',
    }
  },
  mounted() {
    this.GetUporabniki();
  },
  methods: {
    GetUporabniki() {
      axios.get('./api/uporabniki/izpis/', {withCredentials: true}).then((response) => {
        this.uporabniki = response.data.uporabniki;
        this.TwoAuthEnabled();
      }).catch((napaka) => {
        this.text = "Napaka:" + napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    TwoAuthEnabled() {
      this.twoAuthed = this.uporabniki.filter((u) => u.twoAuth === true);
    },
    DisableTwoAuth(id) {
      this.izbranUser = id;
      var podatki = new URLSearchParams();
      podatki.append('uID', this.twoAuthed[id].id);
      axios.post('./api/uporabniki/izpis/', podatki, {withCredentials: true}).then((response) => {
        this.userID = response.data.email;
        this.DisableAuth();
      }).catch((napaka) => {
        this.text = "Napaka:" + napaka;
        this.types = "Napaka";
        this.ShowNoti = true;
      });
    },
    DisableAuth() {
      this.text = 'Ste prepričani, da želite izklopiti 2FA za ' + this.userID + '? Po potrditvi dejanja ni mogoče razveljaviti!';
      this.types = 'Vprašanje';
      this.ShowNoti = true;
    },
    Disable() {
      var podatki = new URLSearchParams();
      podatki.append('uEmail', this.userID);
      axios.post('./api/prijava/multiauth/izklopi/', podatki, {withCredentials: true}).then((response) => {
        this.text = response.data.sporocilo + ' za uporabnika ' + this.userID;
        this.types = 'Uspešno';
        this.ShowNoti = true;
        this.userID = '';
        this.TwoAuthEnabled();
      }).catch((napaka) => {
        if (napaka.response.status === 401) {
          this.$router.push('/Logout');
        }
        if (napaka.response.data.napaka !== undefined) {
          this.text = 'Napaka pri branju podatkov. ' + napaka.response.data.napaka;
        } else {
          this.text = 'Napaka pri branju podatkov.';
        }
        this.types = 'Napaka';
        this.ShowNoti = true;
      });
    },
    Cancel() {
      this.ShowNoti = false;
      this.twoAuthed[this.izbranUser].twoAuth = true;
    },
  }
}
</script>
<template>
  <div class="pregled-povrsin-container">
    <main class="main-content" >
      <div class="form-section">
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-info-circle"></i>
          </div>
          <div class="section-title">
            <h3>Upravljanje dvostopenjskih prijav</h3>
            <!-- <p>Osnovne informacije o letališču</p> -->
          </div>
        </div>
        <div class="section-content">
          <p class='text-danger'>Izklop dvo-stopenjske avtentikacije uporabnikom, ki imajo dvo-stopenjsko avtentikacijo aktivirano. <br/>! POZOR ! Po izklopu dejanja ni več mogoče razveljaviti.</p>
        </div>
      </div>
      <div class="form-section d-flex justify-content-between" v-for='(user, key) in twoAuthed'>
        <div class="section-header">
          <div class="section-icon">
            <i class="fas fa-user-shield"></i>
          </div>
          <div class="section-title">
            <h3>{{user.ime}} {{user.priimek}}</h3>
          </div>
        </div>
        <div class='section-content'>
          <label class='switch col-6'>
            <input type='checkbox' v-model="twoAuthed[key].twoAuth" @change.prevent="DisableTwoAuth(key)" :checked="user.twoAuth">
            <span class="slider round"></span>
          </label>
        </div>
      </div>
    </main>
  </div>
  <!-- OBVESTILA -->
  <Transition name="fade">
    <Notification v-if="ShowNoti" :message="this.text" :type="this.types" @da='Disable()' @ne='Cancel()' @closeNotification="ShowNoti = false" />
  </Transition>
</template>